import React from 'react';
import { useAuth } from '../auth/AuthProvider';
import { EmptyState, PageHeader, Screen } from '../ui';
import { isPermitted } from './registry';
import type { ScreenDef } from './types';

function NoAccess({ title }: { title: string }) {
  return (
    <Screen>
      <PageHeader title={title} />
      <EmptyState icon="lock" title="You don't have access to this page" description="Ask your HR administrator if you think you should." />
    </Screen>
  );
}

const cache = new Map<string, React.ComponentType<any>>();

/** Wraps a registry component with its permission check (stable component identity per screen). */
export function gated(def: ScreenDef): React.ComponentType<any> {
  let C = cache.get(def.name);
  if (!C) {
    const Inner = def.component;
    C = function GatedScreen(props: any) {
      const { can } = useAuth();
      return isPermitted(def, can) ? <Inner {...props} /> : <NoAccess title={def.title} />;
    };
    C.displayName = `Gated(${def.name})`;
    cache.set(def.name, C);
  }
  return C;
}

export function NotFound() {
  return (
    <Screen>
      <PageHeader title="Page not found" back />
      <EmptyState icon="alert" title="We couldn't find that page" description="The link may be old, or the page may have moved." />
    </Screen>
  );
}
